import styled, { css } from 'styled-components';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';

export const CustomAppBar = styled(AppBar)`
  background: #ffffff;
  color: #1a1a2e;
  border-radius: 12px;
  padding: 0 10px;
  overflow: hidden;
  border: 1px solid rgba(26, 26, 46, 0.08);
  box-shadow: 0 2px 12px rgba(26, 26, 46, 0.06);
`;

export const CustomToolbar = styled(Toolbar)`
  /* Beat MUI's breakpoint min-heights (56px / 64px) for a slimmer bar. */
  && {
    min-height: 52px;
  }
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const NavButtonsWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  color: #1a1a2e;
  gap: clamp(12px, 4vw, 40px);
  flex: 1;
  margin-left: 24px;

  ${({ $compact }) =>
    $compact &&
    css`
      justify-content: flex-start;
      flex: 0 0 auto;
      margin-left: 10px;
      gap: 14px;

      button {
        font-size: 18px;
        padding-left: 10px;
        padding-right: 10px;
      }
    `}

  button {
    text-transform: none;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 600;
    font-size: 16px;
    white-space: nowrap;
    position: relative;
    padding-bottom: 6px;

    &::after {
      content: '';
      position: absolute;
      bottom: 2px;
      left: 50%;
      width: 0;
      height: 2px;
      background: #0d4efe;
      border-radius: 1px;
      transition: all 0.3s ease;
      transform: translateX(-50%);
    }

    &:hover {
      color: #0d4efe;
      background: rgba(13, 78, 254, 0.05);

      &::after {
        width: 60%;
      }
    }
  }

  @media (max-width: 960px) {
    display: none;
  }
`;

export const NavBarSection = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 16px;
  flex: 1;
`;

export const NavLogoWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0;
`;

export const NavLogo = styled.img`
  height: 32px;
  width: auto;
  display: block;
  object-fit: contain;
`;

export const RightSection = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1;
  padding-right: 16px;

  button {
    background: #0d4efe;
    color: #ffffff;
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-weight: 700;
    font-size: 15px;
    text-transform: none;
    padding: 6px 20px;
    border-radius: 50px;
    box-shadow: none;
    transition: all 0.25s ease;

    &:hover {
      background: #0b43dc;
      box-shadow: 0 4px 12px rgba(13, 78, 254, 0.25);
      transform: translateY(-1px);
    }
  }
`;

export const IconGroup = styled(Box)`
  display: flex;
  gap: 12px;
  align-items: center;
  margin-right: 16px;

  svg {
    color: #0d4efe;
    font-size: 36px;
    padding: 10px;
    border-radius: 50%;
    background: rgba(13, 78, 254, 0.07);
    cursor: pointer;
    transition: all 0.2s ease;
    width: 44px;
    height: 44px;

    &:hover {
      background: rgba(13, 78, 254, 0.14);
      transform: translateY(-1px);
    }
  }
`;

export const MobileMenuButton = styled(IconButton)`
  color: #1a1a2e;
  padding: 8px;

  svg {
    font-size: 28px;
  }
`;

export const MobileDrawerContent = styled(Box)`
  width: 280px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const MobileDrawerHeader = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #ffffff;
  border-bottom: 1px solid rgba(26, 26, 46, 0.08);
`;

export const MobileDrawerLogo = styled.img`
  height: 36px;
  width: auto;
  max-width: 160px;
  display: block;
  object-fit: contain;
`;

export const MobileDrawerList = styled(List)`
  flex: 1;
  padding: 8px 0;

  .MuiListItemButton-root {
    padding: 12px 24px;
    border-radius: 8px;
    margin: 4px 8px;

    &:hover {
      background-color: rgba(13, 78, 254, 0.08);
    }
  }
`;